
export interface IEntryPageOption {
    title: string;
    description: string;
    value: number;
}

export interface IEntryPageConfiguration {
    display: boolean;
    currency?: string;
    options?: IEntryPageOption[];
}

export interface IWidgetConfiguration {
    merchantCode: string | null;
    merchantCodes?: string[];
    showMarketingConsent: boolean;
    marketingConsentText: string | null;
    defaultOffsetAmount: number | null;
    defaultCurrency: string | null;
    hidePoweredBy: boolean;
    entryPage: IEntryPageConfiguration;
    enableCo2amountField: boolean;
    termsAndConditionsHtml?: string;
}

const defaultConfiguration: IWidgetConfiguration = {
    merchantCode: null,
    showMarketingConsent: false,
    marketingConsentText: null,
    hidePoweredBy: false,
    defaultOffsetAmount: 5,
    defaultCurrency: 'USD',
    enableCo2amountField: true,
    entryPage: {
        display: false
    },
    termsAndConditionsHtml: `<p>By completing the purchase process on CarbonClick, you agree to our 
      <a href="https://www.carbonclick.com/legal/terms-of-trade/" target="_blank" rel="noopener noreferrer">Terms of Sale</a> and 
      <a href="https://www.carbonclick.com/legal/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>, including the purposes for processing personal data.</p>`,
};

const configurations: IWidgetConfiguration[] = [
    defaultConfiguration,
    {
        merchantCode: null,
        merchantCodes: [
            'BUS_AE_EXPO_CITY_DUBAI',
            'BUS_AE_EXPO_EVENT',
            'BUS_AE_EXPO_TICKETMASTER',
            'BUS_AE_EXPO_PLATINUMLIST',
            'BUS_AE_EXPO_CVENT',
            'BUS_AE_EXPO_EMPLOYEE',
            'BUS_AE_EXPO_CUSTOMER',
            'BUS_AE_EXPO_PHYSICAL1',
            'BUS_AE_EXPO_PHYSICAL2'
        ],
        showMarketingConsent: true,
        marketingConsentText: 'I agree to receive communications from Expo City Dubai about news, events, and promotions.',
        hidePoweredBy: false,
        defaultOffsetAmount: 5,
        defaultCurrency: 'USD',
        enableCo2amountField: true,
        entryPage: {
            display: false
        },
        termsAndConditionsHtml: `<p>By completing the purchase process on CarbonClick, you agree to CarbonClick’s 
            <a href="https://www.carbonclick.com/legal/terms-of-trade/" target="_blank" rel="noopener noreferrer">Terms of Sale</a>, 
            <a href="https://www.carbonclick.com/legal/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and Expo City Dubai’s
            <a href="" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>, including the purposes for processing personal data.</p>`,
    },
    {
        merchantCode: 'BUS_AE_DUBAI_AIRPORTS',
        showMarketingConsent: false,
        marketingConsentText: null,
        hidePoweredBy: false,
        defaultOffsetAmount: 100,
        defaultCurrency: 'AED',
        enableCo2amountField: true,
        entryPage: {
            display: false
        }
    },
    {
        merchantCode: 'BUS_US_OIETJHIOETJH',
        showMarketingConsent: true,
        marketingConsentText: 'I agree to receive communications from Alexander about news, events, and promotions.',
        hidePoweredBy: false,
        defaultOffsetAmount: 5,
        defaultCurrency: 'USD',
        enableCo2amountField: true,
        entryPage: {
            display: true,
            currency: 'USD',
            options: [
                {
                    title: 'Local',
                    description: 'A contribution of $5 USD covers most ground travel up to 500 km.',
                    value: 5
                },
                {
                    title: 'Regional',
                    description: 'A contribution of $15 USD covers travel up to 1000 km and 3 nights at a 4 star hotel.',
                    value: 15
                },
                {
                    title: 'International',
                    description: 'A contribution of $30 USD offsets a long-haul flight in economy class and up to a week at a hotel.',
                    value: 30
                },
                {
                    title: 'TEST 1',
                    description: 'A contribution of $50 USD offsets a long-haul flight in economy class and up to a week at a hotel.',
                    value: 50
                },
                {
                    title: 'TEST 2',
                    description: 'A contribution of $100 USD offsets a long-haul flight in economy class and up to a week at a hotel.',
                    value: 100
                }
            ]
        }
    },
];

export const getConfiguration = (merchantCode: string):IWidgetConfiguration => {
    const configuration = configurations.find(config => config.merchantCode === merchantCode || config.merchantCodes?.includes(merchantCode));
    return configuration || defaultConfiguration;
};